import { useMutation, useQuery } from "react-query";
import {
  addReportCategory,
  getAllReportCategories,
  getReportCategoryById,
} from "../api/report-category";

const useGetReportCategories = (options) =>
  useQuery(["useGetReportCategories"], getAllReportCategories, options);

const useGetReportCategoryById = (id, options) =>
  useQuery(
    ["useGetReportCategories", id],
    () => getReportCategoryById,
    options,
  );

const useAddReportCategory = (options) =>
  useMutation(addReportCategory, options);

export {
  useGetReportCategories,
  useGetReportCategoryById,
  useAddReportCategory,
};
